import React from "react";
import { Link } from "react-router-dom";
import { Flame, Mail, Phone, MapPin, Facebook, Instagram, Twitter, Youtube } from "lucide-react";

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "https://facebook.com" },
  { icon: Instagram, label: "Instagram", href: "https://instagram.com" },
  { icon: Twitter, label: "Twitter", href: "https://twitter.com" },
  { icon: Youtube, label: "YouTube", href: "https://youtube.com" },
];

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-border bg-background" data-testid="site-footer">
      <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="space-y-4">
          <div className="flex items-center gap-2.5">
            <span className="h-9 w-9 grid place-items-center rounded-full bg-gradient-to-br from-accent to-primary text-white"><Flame className="h-4 w-4" /></span>
            <span className="font-serif text-lg font-bold">Pavitra Mantra</span>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Connecting devotees with sacred Mandirs and verified Purohits for authentic worships and Vedic rituals, performed with devotion.
          </p>
          <p className="font-devanagari text-sm text-accent">॥ सर्वे भवन्तु सुखिनः ॥</p>
          <div className="flex items-center gap-2.5 pt-1" data-testid="footer-socials">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}
                data-testid={`social-${s.label.toLowerCase()}`}
                className="h-9 w-9 grid place-items-center rounded-full border border-border text-muted-foreground hover:text-accent hover:border-accent transition-colors">
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-serif text-sm font-semibold uppercase tracking-widest mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm text-muted-foreground">
            <li><Link to="/mandirs" className="hover:text-primary">Mandirs</Link></li>
            <li><Link to="/divine-bless" className="hover:text-primary">Book Worship</Link></li>
            <li><Link to="/divine-bless" className="hover:text-primary">Book Vedic Rituals</Link></li>
            <li><Link to="/vedic-services" className="hover:text-primary">Vedic Services</Link></li>
            <li><Link to="/blog" className="hover:text-primary">Vedic Blog</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-sm font-semibold uppercase tracking-widest mb-4">Company</h4>
          <ul className="space-y-2.5 text-sm text-muted-foreground">
            <li><Link to="/about" className="hover:text-primary">About Us</Link></li>
            <li><Link to="/about" className="hover:text-primary">Contact & Support</Link></li>
            <li><Link to="/about" className="hover:text-primary">FAQ</Link></li>
            <li><Link to="/purohit" className="hover:text-primary">Register as Purohit</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-sm font-semibold uppercase tracking-widest mb-4">Legal</h4>
          <ul className="space-y-2.5 text-sm text-muted-foreground" data-testid="footer-legal">
            <li><Link to="/legal/terms" data-testid="legal-terms" className="hover:text-primary">Terms &amp; Conditions</Link></li>
            <li><Link to="/legal/privacy" data-testid="legal-privacy" className="hover:text-primary">Privacy Policy</Link></li>
            <li><Link to="/legal/cookies" data-testid="legal-cookies" className="hover:text-primary">Cookies Settings</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-sm font-semibold uppercase tracking-widest mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent" /> pm.pavitramantra@gmail.com</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-accent" /> +916294986115</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-accent" /> Deoghar, Jharkhand</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Pavitra Mantra. Crafted with devotion. All worships performed by verified Purohits.
      </div>
    </footer>
  );
}
